import { SVGProps } from "react";

export function WithdrawIcon({
  size = 24,
  color = "currentColor",
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props as any)}
    >
      <path
        d="M12 0L15 4.5H13.5V7.5H10.5V4.5H9L12 0ZM22.5 10.5V22.5H1.5V10.5H22.5ZM24 9H0V24H24V9Z"
        fill={color}
      />
      <path
        d="M12 12C12.5909 12 13.1761 12.1164 13.7221 12.3425C14.268 12.5687 14.7641 12.9002 15.182 13.318C15.5998 13.7359 15.9313 14.232 16.1575 14.7779C16.3836 15.3239 16.5 15.9091 16.5 16.5C16.5 17.0909 16.3836 17.6761 16.1575 18.2221C15.9313 18.768 15.5998 19.2641 15.182 19.682C14.7641 20.0998 14.268 20.4313 13.7221 20.6575C13.1761 20.8836 12.5909 21 12 21H19.5V19.5H21V13.5H19.5V12H12ZM7.5 16.5C7.5 15.3065 7.97411 14.1619 8.81802 13.318C9.66193 12.4741 10.8065 12 12 12H4.5V13.5H3V19.5H4.5V21H12C10.8065 21 9.66193 20.5259 8.81802 19.682C7.97411 18.8381 7.5 17.6935 7.5 16.5Z"
        fill={color}
      />
    </svg>
  );
}
